import { useResearchStudioStore } from "@/stores/ResearchStudioStore";
import { logPageVisit } from "@/helpers/userEvents";

const logSurveyDetailsPageVisit = (to, from) => {
  const researchStudioStore = useResearchStudioStore();
  const survey = researchStudioStore.surveys.find(
    (s) => s.id === parseInt(to.params.survey_id),
  );

  logPageVisit(to, from, {
    survey_name: survey?.name,
    survey_id: to.params.survey_id,
  });
};

export { logSurveyDetailsPageVisit };
